import { AbsShare } from "./AbsShare";
import { navigatorShare } from "../Utils";
import { BtnShareTrigger } from "./feature/BtnShareTrigger";
import { COMMON } from "..";
import BreakpointFeature from "./feature/Breakpoint";

// const COMMON = 'COMMON'
// 옵션에서 navigatorShare 사용하며, 디바이스가 모바일이고, share 객체가 있을때
export class ShareNavigator extends AbsShare {
    breakpoint: BreakpointFeature | null = null;
    btnShareTrigger: BtnShareTrigger | null = null;

    constructor(private optionMap: ShareOptionMap){
        super();

        this.setBreakpoint();
        this.create();
    }

    create(){
        // 공유하기 트리거 버튼 생성
        this.setBtnShareTrigger();
    }

    remove(): void {
        // 공유하기 트리거 버튼 삭제
        this.btnShareTrigger?.remove();
    }

    async open(): Promise<void> {
      try{
        await this.option.beforeShareAsync();
        await navigatorShare(this.option.shareUrl, this.option.title);
        await this.option.afterShareAsync();
      }catch{
        return;
      }
        
    }

    close(): void {
        // void
    }

    // navigator.share 의 open/close 시점을 잡을수 없음. https://developer.mozilla.org/en-US/docs/Web/API/Navigator/share 에는 리턴으로 promise를 준다고 나오는데, 모바일에서 강제종료(화면바닦 클릭)하면 resolve 안됨..
    toggle(): void{
        this.open();
    }

    get option(): ShareOption{
        if(this.breakpoint){
            return this.optionMap[this.breakpoint.currentBreakPoint];
        }else{
            return this.optionMap[COMMON];
        }
    }

    //  breakpoint 설정
    setBreakpoint(){
        // breakpoint 가 있으면
        if(BreakpointFeature.hasBreakpoints(Object.keys(this.optionMap))){
            // breakpoint 인스턴스 생성
            this.breakpoint = new BreakpointFeature(Object.keys(this.optionMap));
            // breakpoint 이벤트 세팅
            this.breakpoint.onChangeBreakpoint(() => this.onChangeBreakpointCallback())
        }
    }
    
    updateOption(optionMap: ShareOptionMap){
      this.optionMap = optionMap;

      this.reRendering();
    }
 
    // breakpoint 이벤트
    onChangeBreakpointCallback(){
      this.reRendering();;
    }
    public reRendering(){
      this.remove();
      this.create();
    }
    setBtnShareTrigger() {
        const BtnShareTriggerOption = this.option.btnShareTrigger

        if(!BtnShareTriggerOption) return

        if( BtnShareTrigger.canUse(BtnShareTriggerOption)){
            this.btnShareTrigger = new BtnShareTrigger(this, BtnShareTriggerOption);
        }
    }
}

